import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router/composables'
import { useAuth } from '@/composables/useAuth'
import pcMenu from '@/assets/header/pc-menu.json'

type PcMenuLink = { id: string; label: string; href: string }
type PcMenuItem = {
  id: string
  label: string
  href?: string
  children?: PcMenuLink[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
    isYagiPrime: { type: Boolean, default: false },
    isYagiPrimeCancel: { type: Boolean, default: false },
    csCount: { default: 0 },
    isOemDisplayAllowed: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { isYagiPrime: boolean, isYagiPrimeCancel: boolean, csCount: number, isOemDisplayAllowed: boolean };



const route = useRoute()
const { user, isAuthenticated } = useAuth()

const pcMenuItems = pcMenu.items as PcMenuItem[]

const isYagiPrimeActive = computed(
  () => props.isYagiPrime && !props.isYagiPrimeCancel
)

/** 障がい者向け書式ではサービスメニューを出さない（移設元の v-if を踏襲） */
const showServiceMenu = computed(
  () => route.params.formatId !== 'rirekisho_esf_challenged'
)

const userEmail = computed(() => user.value?.email ?? '')
const userDisplayName = computed(() => user.value?.displayName ?? '')

return { __sfc: true,props, route, user, isAuthenticated, pcMenuItems, isYagiPrimeActive, showServiceMenu, userEmail, userDisplayName }
}

})